import { app } from '@store/modules/app';
import { AxiosRequestConfig } from 'axios';

export function oAuthTokenHeader(config: AxiosRequestConfig): AxiosRequestConfig {
	if (config.headers) {
		config.headers.authorization = `Bearer ${app.oauthToken}`;
	}
	return config;
}
